module.exports = __webpack_public_path__ + "static/img/scene_photo_drive.1aa0b5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/scene_photo_drive.jpg
// module id = ax4q
// module chunks = 1